import React, {Component} from "react"
import {Col, Row} from "elemental"
import "./Form.scss"
import {browserHistory} from "react-router"
import FormCMS from "theme/components/Form/FormCMS"

export default class FormPage extends Component {

  render() {
    let slug = this.props.params.slug
    return (
      <div className="container pt4">
        <div className="">
          <Row>
            <Col sm="1/2">
              <FormCMS slug={slug} onSuccess={() => {
                browserHistory.push( "/" )
                window.swal( "Anfrage erhalten", "Vielen Dank für Ihre Nachricht",
                  "success" )
              }}/>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/theme/pages/form/FormPage.js